































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































import Vue from "vue";
import { RequestService } from "@/services";
import { PnetDatePicker } from "@previnet/vue-datepicker";
import { it } from "vuejs-datepicker/dist/locale";
import data, { selectChoices } from "@/services/data";
import properties, {propertyTypes} from "@/services/properties";
import moment from "moment";
import { isNil } from "ramda";
import TextField from "@/components/TextField.vue";
import ComboBox from "@/components/ComboBox.vue";
import DatePicker from "@/components/DatePicker.vue";
import { PnetInput } from "@previnet/vue-input";
import RangeValues from "@/components/RangeValues.vue";
import Kid from "@/components/Kid.vue";
import NestedRangeValues from "@/components/NestedRangeValues.vue";
import TipologiaCommissioneFondi from "@/components/TipologiaCommissioneFondi.vue";
import CommissioneFondi from "@/components/CommissioneFondi.vue";
import Gkid from "@/components/Gkid.vue";
import { format } from "date-fns";
import Header from "@/components/Header.vue";

const requestService = new RequestService();
const handleResponse = (response: Response) => {
  if (!response.ok) {
    // TODO handle errori
  } else {
    return response.json();
  }
};

export default Vue.extend({
  props: ['productId', 'user'],
  components: {
    PnetDatePicker,
    PnetInput,
    TextField,
    ComboBox,
    DatePicker,
    RangeValues,
    Kid,
    NestedRangeValues,
    CommissioneFondi,
    TipologiaCommissioneFondi,
    Gkid,
    Header,
  },
  data: function() {
    return {
      loggedUser: this.$props.user,
      errorMsg: null as any,
      okMsg: null as any,
      esitoRegistrazione: null as any,
      productIdSelected: this.$props.productId,
      it,
      ND: "n.d.",

      ...data,
      ...properties,
      selectChoices,
      propertyTypes
    };
  },

  methods: {
    openModalConfirm: function() {
      const vm = this as any;
      if (vm.checkFields() == true) {
        vm.valorizzaTendine();

        if (vm.errorMsg == null) {
          vm.$bvModal.show("modal-confirm");
        }
      }
    },
    closeModalConfirm() {
      const vm = this as any;
      vm.$bvModal.hide("modal-confirm");
    },
    openModalConfirmOutcome() {
      const vm = this as any;
      vm.$bvModal.show("modal-confirm-outcome");
    },
    closeModalConfirmOutcome() {
      const vm = this as any;
      vm.$bvModal.hide("modal-confirm-outcome");
    },
    openModalError() {
      const vm = this as any;
      vm.$bvModal.show("modal-error");
    },
    closeModalError() {
      const vm = this as any;
      vm.$bvModal.hide("modal-error");
    },
    onClickReturnConfirmOutcome() {
      const vm = this as any;
      vm.closeModalConfirmOutcome();
    },
    onClickReturnError() {
      const vm = this as any;
      vm.closeModalError();
    },
    startLoading() {
      const vm = this as any;
      vm.$loadingService.startLoading("loading");
    },
    stopLoading() {
      const vm = this as any;
      vm.$loadingService.stopLoading("loading");
    },
    valorizzaTendine: function() {
      const vm = this as any;

      // FUNZIONI DI MAPPING PER PRENDERE CODE E DESCRIZIONE
      properties.mercatoProperty.code = selectChoices.mercato.code;
      properties.mercatoProperty.value = selectChoices.mercato.description;
      properties.destinatariProperty.code = selectChoices.destinatari.code;
      properties.destinatariProperty.value = selectChoices.destinatari.description;
      properties.canaleProperty.code = selectChoices.canale.code;
      properties.canaleProperty.value = selectChoices.canale.description;
      properties.tipoProdottoProperty.code = selectChoices.tipoProdotto.code;
      properties.tipoProdottoProperty.value = selectChoices.tipoProdotto.description;
      properties.tipoSottostantiProperty.code = selectChoices.tipoSottostanti.code;
      properties.tipoSottostantiProperty.value = selectChoices.tipoSottostanti.description;
      properties.prodCommProperty.code = selectChoices.prodComm.code;
      properties.prodCommProperty.value = selectChoices.prodComm.description;
      properties.tipoPremioProperty.code = selectChoices.tipoPremio.code;
      properties.tipoPremioProperty.value = selectChoices.tipoPremio.description;
      properties.prodCollegatoProperty.code = selectChoices.prodCollegato.code;
      properties.prodCollegatoProperty.value = selectChoices.prodCollegato.description;

      if (selectChoices.prodCollegato.code != '11.2b') {
        properties.relazioneProdCollegatoProperty.code = selectChoices.relazioneProdCollegato.code;        
        properties.relazioneProdCollegatoProperty.value = selectChoices.relazioneProdCollegato.description;
      }

      properties.tipologiaDurationProperty.code = selectChoices.tipologiaDuration.code;
      properties.tipologiaDurationProperty.value = selectChoices.tipologiaDuration.description;
      properties.tipoCalcoloBonusIngressoProperty.code = selectChoices.tipoCalcoloBonusIngresso.code;
      properties.tipoCalcoloBonusIngressoProperty.value = selectChoices.tipoCalcoloBonusIngresso.description;
      properties.tipoCalcoloBonusFedeltaProperty.code = selectChoices.tipoCalcoloBonusFedelta.code;
      properties.tipoCalcoloBonusFedeltaProperty.value = selectChoices.tipoCalcoloBonusFedelta.description;
      properties.tipologiaUpfrontFeeProperty.code = selectChoices.tipologiaUpfrontFee.code;
      properties.tipologiaUpfrontFeeProperty.value = selectChoices.tipologiaUpfrontFee.description;

      if (vm.isGestioneSeparata()) {
        properties.tipoCommGestioneSeparataProperty.code = selectChoices.tipoCommGestioneSeparata.code;
        properties.tipoCommGestioneSeparataProperty.value = selectChoices.tipoCommGestioneSeparata.description;
      }

      if (!vm.isNDCommissioneFondiInterni()) {
        properties.tipoCommFondiInterniAzionariProperty.code = selectChoices.tipoCommFondiInterniAzionari.code;
        properties.tipoCommFondiInterniAzionariProperty.value = selectChoices.tipoCommFondiInterniAzionari.description;
        properties.tipoCommFondiInterniObbligazionariProperty.code = selectChoices.tipoCommFondiInterniObbligazionari.code;
        properties.tipoCommFondiInterniObbligazionariProperty.value = selectChoices.tipoCommFondiInterniObbligazionari.description;
        properties.tipoCommFondiInterniBilanciatiProperty.code = selectChoices.tipoCommFondiInterniBilanciati.code;
        properties.tipoCommFondiInterniBilanciatiProperty.value = selectChoices.tipoCommFondiInterniBilanciati.description;
        properties.tipoCommFondiInterniFlessibiliProperty.code = selectChoices.tipoCommFondiInterniFlessibili.code;
        properties.tipoCommFondiInterniFlessibiliProperty.value = selectChoices.tipoCommFondiInterniFlessibili.description;
        properties.tipoCommFondiInterniMonetariProperty.code = selectChoices.tipoCommFondiInterniMonetari.code;
        properties.tipoCommFondiInterniMonetariProperty.value = selectChoices.tipoCommFondiInterniMonetari.description;
      }

      if (!vm.isNdOICR()) {
        properties.tipologiaCommissioneOICRProperty.code = selectChoices.tipologiaCommissioneOICR.code;
        properties.tipologiaCommissioneOICRProperty.value = selectChoices.tipologiaCommissioneOICR.description;
      }

      properties.commissioniOverperformanceProperty.code = selectChoices.commissioniOverperformance.code;
      properties.commissioniOverperformanceProperty.value = selectChoices.commissioniOverperformance.description;
      properties.applicazioneCommissioniUscitaProperty.code = selectChoices.applicazioneCommissioniUscita.code;
      properties.applicazioneCommissioniUscitaProperty.value = selectChoices.applicazioneCommissioniUscita.description;
      properties.KIDProperty.code = selectChoices.KID.code;
      properties.KIDProperty.value = selectChoices.KID.description;
    },
    inserisciProdotto: async function() {
      const vm = this as any;
      vm.startLoading();
      let productId = undefined;

      if (vm.productIdSelected === undefined) {
        let nuovoProdotto = {} as any;
        nuovoProdotto = await vm.registraProdotto();
        if (nuovoProdotto == undefined) {
          vm.stopLoading();
          vm.openModalError();
        } else {
          productId = nuovoProdotto.productId;
        }
      } else {
        productId = vm.productIdSelected;
      }

      if (productId === undefined) {
        vm.stopLoading();
        vm.openModalError();
      } else {
        //FINE FUNZIONI DI MAPPING
        vm.valorizzaTendine();

        vm.setDatePropertiesValue();

        vm.setPropertiesType();

        vm.setPropertiesDefaultCode();

        const propList = [
          properties.nomeProperty,
          properties.emittenteProperty,
          properties.distributoreProperty,
          properties.mercatoProperty,
          properties.destinatariProperty,
          properties.canaleProperty,
          properties.tipoProdottoProperty,
          properties.tipoSottostantiProperty,
          properties.edizioneProperty,
          properties.prodCommProperty,
          properties.inizioCommProperty,
          properties.fineCommProperty,
          properties.tipoPremioProperty,
          properties.prodCollegatoProperty,
          properties.codProdCollegatoProperty,
          properties.relazioneProdCollegatoProperty,
          properties.orizzonteTemporaleProperty,
          properties.tipologiaDurationProperty,
          properties.dataScadenzaProperty,
          properties.importoMinimoProperty,
          properties.importoMassimoProperty,
          properties.retrocessioneUpfrontProperty,
          properties.retrocessioneGestSepProperty,
          properties.retrocessioneRamIIIProperty,
          properties.gsWeightMinProperty,
          properties.gsWeightMaxProperty,
          properties.tipoCalcoloBonusIngressoProperty,
          properties.bonusIngressoProperty,
          properties.tipoCalcoloBonusFedeltaProperty,
          properties.bonusFedeltaProperty,
          properties.speseAmministrativeAperturaContrattoProperty,
          properties.speseAmministrativeVersamentoPACProperty,
          properties.tipologiaUpfrontFeeProperty,
          properties.upfrontFeeRangeProperty,
          properties.tipoCommGestioneSeparataProperty,
          properties.commGestioneSeparataProperty,
          properties.tipoCommFondiInterniAzionariProperty,
          properties.tipoCommFondiInterniObbligazionariProperty,
          properties.tipoCommFondiInterniBilanciatiProperty,
          properties.tipoCommFondiInterniFlessibiliProperty,
          properties.tipoCommFondiInterniMonetariProperty,
          properties.commFondiInterniAzionariProperty,
          properties.commFondiInterniObbligazionariProperty,
          properties.commFondiInterniBilanciatiProperty,
          properties.commFondiInterniFlessibiliProperty,
          properties.commFondiInterniMonetariProperty,
          properties.tipologiaCommissioneOICRProperty,
          properties.commissioneOICRAzionariProperty,
          properties.commissioneOICRObbligazionariProperty,
          properties.commissioneOICRBilanciatiProperty,
          properties.commissioneOICRFlessibiliProperty,
          properties.commissioneOICRMonetariProperty,
          properties.commissioniOverperformanceProperty,
          properties.costoGaranziaMorteProperty,
          properties.applicazioneCommissioniUscitaProperty,
          properties.commissioneUscitaProperty,
          properties.KIDProperty,
          properties.scenarioKIDStressProperty,
          properties.scenarioKIDSfavorevoleProperty,
          properties.scenarioKIDModeratoProperty,
          properties.scenarioKIDFavorevoleProperty,
          properties.scenarioKIDCasoMorteProperty,
          properties.GKIDProperty,
          properties.campoNoteProperty
        ];

        const serviceCallReturnValue = await requestService
          .addProductPropertyList({
            productId: productId,
            propertyList: propList
          })
          .then(handleResponse)
          .then((result: any) => {
            if (!isNil(result.productId)) {
              vm.esitoRegistrazione = "Registrazione avvenuta con successo";
            } else {
              vm.esitoRegistrazione = "Registrazione KO";
            }

            return result.productId;
          })
          .catch(() => {
            vm.openModalError();
          });

        vm.stopLoading();

        vm.closeModalConfirm();

        vm.openModalConfirmOutcome();
      }
    },
    registraProdotto: async function() {
      return requestService.initProduct().then(handleResponse);
      //.then((result: any) => {})
      //.catch();
    },
    getOptionDescriptionByCode: function(code: string, options: any) {
      let description = null;

      const optionscopy = JSON.parse(JSON.stringify(options));

      for (let i = 0, len = optionscopy.length; i < len; i++) {
        const option = optionscopy[i] as any;
        if (option.code == code) {
          description = option.description;
        }
      }

      return description;
    },
    getOptionCodeByDescription: function(description: string, options: any) {
      let code = null;

      for (let i = 0, len = options.length; i < len; i++) {
        const option = options[i] as any;
        if (option.description == description) {
          code = option.code;
        }
      }

      return code;
    },
    setFineComm: function() {
      const vm = this as any;
      properties.fineCommProperty.value = "";
      properties.fineCommProperty.dateValue = null;

      if (selectChoices.prodComm.code == "9.1") {
        properties.fineCommProperty.value = vm.ND;
      }
    },
    resetDataScadenzaProperty: function() {
      const vm = this as any;
      properties.dataScadenzaProperty.value = "";
      properties.dataScadenzaProperty.rangeValues = [
        {
          order: 0,
          from: "",
          to: "",
          value: ""
        }
      ];
      if (
        selectChoices.tipologiaDuration.code == "13.1" ||
        selectChoices.tipologiaDuration.code == "13.5"
      ) {
        properties.dataScadenzaProperty.value = vm.getOptionDescriptionByCode(
          selectChoices.tipologiaDuration.code,
          data.tipologiaDurationOptions
        );
      }
    },

    setCommissioniUscita: function() {
      const vm = this as any;
      if (selectChoices.applicazioneCommissioniUscita.code == "50.2") {
        properties.commissioneUscitaProperty.value = "Non presente";
      } else if (
        selectChoices.applicazioneCommissioniUscita.code == "50.3"
      ) {
        properties.commissioneUscitaProperty.value = "Campo note";
      } else {
        properties.commissioneUscitaProperty.value = "";
        properties.commissioneUscitaProperty.rangeValues = [
          {
            order: 0,
            from: "",
            to: "",
            value: ""
          }
        ];
      }
    },

    resetBonusIngressoProperty: function() {
      const vm = this as any;
      properties.bonusIngressoProperty.value = "";
      properties.bonusIngressoProperty.rangeValues = [ ];

      if (
        selectChoices.tipoCalcoloBonusIngresso.code == "22.6" ||
        selectChoices.tipoCalcoloBonusIngresso.code == "22.7"
      ) {
        properties.bonusIngressoProperty.value = vm.getOptionDescriptionByCode(
          selectChoices.tipoCalcoloBonusIngresso.code,
          data.tipoCalcoloBonusIngressoOptions
        );
      } else if (
        selectChoices.tipoCalcoloBonusIngresso.code == "22.2" ||
        selectChoices.tipoCalcoloBonusIngresso.code == "22.3" ||
        selectChoices.tipoCalcoloBonusIngresso.code == "22.4" ||
        selectChoices.tipoCalcoloBonusIngresso.code == "22.5"
      ) {
        properties.bonusIngressoProperty.rangeValues = [
          {
            order: 0,
            from: "",
            to: "",
            value: ""
          }
        ];
      }
    },
    resetBonusFedeltaProperty: function() {
      const vm = this as any;
      properties.bonusFedeltaProperty.value = "";
      properties.bonusFedeltaProperty.rangeValues = [];

      if (
        selectChoices.tipoCalcoloBonusFedelta.code == "24.3" ||
        selectChoices.tipoCalcoloBonusFedelta.code == "24.4"
      ) {
        properties.bonusFedeltaProperty.value = vm.getOptionDescriptionByCode(
          selectChoices.tipoCalcoloBonusFedelta.code,
          data.tipoCalcoloBonusFedeltaOptions
        );
      } else if (
        selectChoices.tipoCalcoloBonusFedelta.code == "24.1" ||
        selectChoices.tipoCalcoloBonusFedelta.code == "24.2"
      ) {
        properties.bonusFedeltaProperty.rangeValues = [
          {
            order: 0,
            from: "",
            to: "",
            value: ""
          }
        ];
      }
    },
    setKIDStress: function() {
      const vm = this as any;

      if (selectChoices.KID.code == "52.2") {
        properties.scenarioKIDStressProperty.value = vm.ND;
        properties.scenarioKIDModeratoProperty.value = vm.ND;
        properties.scenarioKIDFavorevoleProperty.value = vm.ND;
        properties.scenarioKIDSfavorevoleProperty.value = vm.ND;
        properties.scenarioKIDCasoMorteProperty.value = vm.ND;
      } else {
        properties.scenarioKIDStressProperty.value = "";
        properties.scenarioKIDStressProperty.rangeValues = [ { order: 0, from: "", to: "", value: "" } , { order: 1, from: "", to: "", value: "" } , { order: 2, from: "", to: "", value: "" } ];

        properties.scenarioKIDSfavorevoleProperty.value = "";
        properties.scenarioKIDSfavorevoleProperty.rangeValues = [ { order: 0, from: "", to: "", value: "" } , { order: 1, from: "", to: "", value: "" } , { order: 2, from: "", to: "", value: "" } ];

        properties.scenarioKIDModeratoProperty.value = "";
        properties.scenarioKIDModeratoProperty.rangeValues = [ { order: 0, from: "", to: "", value: "" } , { order: 1, from: "", to: "", value: "" } , { order: 2, from: "", to: "", value: "" } ];

        properties.scenarioKIDFavorevoleProperty.value = "";
        properties.scenarioKIDFavorevoleProperty.rangeValues = [ { order: 0, from: "", to: "", value: "" } , { order: 1, from: "", to: "", value: "" } , { order: 2, from: "", to: "", value: "" } ];

        properties.scenarioKIDCasoMorteProperty.value = "";
        properties.scenarioKIDCasoMorteProperty.rangeValues = [ { order: 0, from: "", to: "", value: "" } , { order: 1, from: "", to: "", value: "" } , { order: 2, from: "", to: "", value: "" } ];
      }
    },
    resetUpfrontFeeRangeProperty: function() {
      const vm = this as any;

      if (selectChoices.tipologiaUpfrontFee.code == "28.11") {
        properties.retrocessioneUpfrontProperty.value = vm.ND;
      }

      properties.upfrontFeeRangeProperty.value = "";
      properties.upfrontFeeRangeProperty.rangeValues = [];

      if (
        selectChoices.tipologiaUpfrontFee.code == "28.11" ||
        selectChoices.tipologiaUpfrontFee.code == "28.12"
      ) {
        properties.upfrontFeeRangeProperty.value = vm.getOptionDescriptionByCode(
          selectChoices.tipologiaUpfrontFee.code,
          data.tipologiaUpfrontFeeOptions
        );
      } else if (
        selectChoices.tipologiaUpfrontFee.code == "28.2" ||
        selectChoices.tipologiaUpfrontFee.code == "28.3" ||
        selectChoices.tipologiaUpfrontFee.code == "28.4" ||
        selectChoices.tipologiaUpfrontFee.code == "28.5" ||
        selectChoices.tipologiaUpfrontFee.code == "28.6" ||
        selectChoices.tipologiaUpfrontFee.code == "28.7" ||
        selectChoices.tipologiaUpfrontFee.code == "28.8" ||
        selectChoices.tipologiaUpfrontFee.code == "28.9" ||
        selectChoices.tipologiaUpfrontFee.code == "28.10"
      ) {
        properties.upfrontFeeRangeProperty.rangeValues = [
          {
            order: 0,
            from: "",
            to: "",
            value: ""
          }
        ];
      }
    },
    resetCommGestioneSeparataProperty: function() {
      const vm = this as any;
      properties.commGestioneSeparataProperty.value = "";
      properties.commGestioneSeparataProperty.rangeValues = [];

      if (selectChoices.tipoCommGestioneSeparata.code == "30.10") {
        properties.commGestioneSeparataProperty.value = vm.getOptionDescriptionByCode(
          selectChoices.tipoCommGestioneSeparata.code,
          data.tipoCommGestioneSeparataOptions
        );
      } else if (
        selectChoices.tipoCommGestioneSeparata.code == "30.2" ||
        selectChoices.tipoCommGestioneSeparata.code == "30.3" ||
        selectChoices.tipoCommGestioneSeparata.code == "30.4" ||
        selectChoices.tipoCommGestioneSeparata.code == "30.5" ||
        selectChoices.tipoCommGestioneSeparata.code == "30.6" ||
        selectChoices.tipoCommGestioneSeparata.code == "30.7" ||
        selectChoices.tipoCommGestioneSeparata.code == "30.8"
      ) {
        properties.commGestioneSeparataProperty.rangeValues = [
          {
            order: 0,
            from: "",
            to: "",
            value: ""
          }
        ];
      }
    },
    resetCommFondiInterniAzionariProperty: function() {
      const vm = this as any;
      properties.commFondiInterniAzionariProperty.value = "";
      properties.commFondiInterniAzionariProperty.rangeValues = [];

      if (
        selectChoices.tipoCommFondiInterniAzionari.code == "32.9" ||
        selectChoices.tipoCommFondiInterniAzionari.code == "32.10"
      ) {
        properties.commFondiInterniAzionariProperty.value = vm.getOptionDescriptionByCode(
          selectChoices.tipoCommFondiInterniAzionari.code,
          data.tipoCommFondiInterniAzionariOptions
        );
      } else if (
        selectChoices.tipoCommFondiInterniAzionari.code == "32.2" ||
        selectChoices.tipoCommFondiInterniAzionari.code == "32.3" ||
        selectChoices.tipoCommFondiInterniAzionari.code == "32.4" ||
        selectChoices.tipoCommFondiInterniAzionari.code == "32.5" ||
        selectChoices.tipoCommFondiInterniAzionari.code == "32.6" ||
        selectChoices.tipoCommFondiInterniAzionari.code == "32.7" ||
        selectChoices.tipoCommFondiInterniAzionari.code == "32.8"
      ) {
        properties.commFondiInterniAzionariProperty.rangeValues = [
          {
            order: 0,
            from: "",
            to: "",
            value: ""
          }
        ];
      }
    },
    resetCommFondiInterniObbligazionariProperty: function() {
      const vm = this as any;
      properties.commFondiInterniObbligazionariProperty.value = "";
      properties.commFondiInterniObbligazionariProperty.rangeValues = [];

      if (
        selectChoices.tipoCommFondiInterniObbligazionari.code == "34.9" ||
        selectChoices.tipoCommFondiInterniObbligazionari.code == "34.10"
      ) {
        properties.commFondiInterniObbligazionariProperty.value = vm.getOptionDescriptionByCode(
          selectChoices.tipoCommFondiInterniObbligazionari.code,
          data.tipoCommFondiInterniObbligazionariOptions
        );
      } else if (
        selectChoices.tipoCommFondiInterniObbligazionari.code == "34.2" ||
        selectChoices.tipoCommFondiInterniObbligazionari.code == "34.3" ||
        selectChoices.tipoCommFondiInterniObbligazionari.code == "34.4" ||
        selectChoices.tipoCommFondiInterniObbligazionari.code == "34.5" ||
        selectChoices.tipoCommFondiInterniObbligazionari.code == "34.6" ||
        selectChoices.tipoCommFondiInterniObbligazionari.code == "34.7" ||
        selectChoices.tipoCommFondiInterniObbligazionari.code == "34.8"
      ) {
        properties.commFondiInterniObbligazionariProperty.rangeValues = [
          {
            order: 0,
            from: "",
            to: "",
            value: ""
          }
        ];
      }
    },
    resetCommFondiInterniBilanciatiProperty: function() {
      const vm = this as any;
      properties.commFondiInterniBilanciatiProperty.value = "";
      properties.commFondiInterniBilanciatiProperty.rangeValues = [];

      if (
        selectChoices.tipoCommFondiInterniBilanciati.code == "36.9" ||
        selectChoices.tipoCommFondiInterniBilanciati.code == "36.10"
      ) {
        properties.commFondiInterniBilanciatiProperty.value = vm.getOptionDescriptionByCode(
          selectChoices.tipoCommFondiInterniBilanciati.code,
          data.tipoCommFondiInterniBilanciatiOptions
        );
      } else if (
        selectChoices.tipoCommFondiInterniBilanciati.code == "36.2" ||
        selectChoices.tipoCommFondiInterniBilanciati.code == "36.3" ||
        selectChoices.tipoCommFondiInterniBilanciati.code == "36.4" ||
        selectChoices.tipoCommFondiInterniBilanciati.code == "36.5" ||
        selectChoices.tipoCommFondiInterniBilanciati.code == "36.6" ||
        selectChoices.tipoCommFondiInterniBilanciati.code == "36.7" ||
        selectChoices.tipoCommFondiInterniBilanciati.code == "36.8"
      ) {
        properties.commFondiInterniBilanciatiProperty.rangeValues = [
          {
            order: 0,
            from: "",
            to: "",
            value: ""
          }
        ];
      }
    },
    resetCommFondiInterniFlessibiliProperty: function() {
      const vm = this as any;
      properties.commFondiInterniFlessibiliProperty.value = "";
      properties.commFondiInterniFlessibiliProperty.rangeValues = [];

      if (
        selectChoices.tipoCommFondiInterniFlessibili.code == "38.9" ||
        selectChoices.tipoCommFondiInterniFlessibili.code == "38.10"
      ) {
        properties.commFondiInterniFlessibiliProperty.value = vm.getOptionDescriptionByCode(
          selectChoices.tipoCommFondiInterniFlessibili.code,
          data.tipoCommFondiInterniFlessibiliOptions
        );
      } else if (
        selectChoices.tipoCommFondiInterniFlessibili.code == "38.2" ||
        selectChoices.tipoCommFondiInterniFlessibili.code == "38.3" ||
        selectChoices.tipoCommFondiInterniFlessibili.code == "38.4" ||
        selectChoices.tipoCommFondiInterniFlessibili.code == "38.5" ||
        selectChoices.tipoCommFondiInterniFlessibili.code == "38.6" ||
        selectChoices.tipoCommFondiInterniFlessibili.code == "38.7" ||
        selectChoices.tipoCommFondiInterniFlessibili.code == "38.8"
      ) {
        properties.commFondiInterniFlessibiliProperty.rangeValues = [
          {
            order: 0,
            from: "",
            to: "",
            value: ""
          }
        ];
      }
    },
    resetCommFondiInterniMonetariProperty: function() {
      const vm = this as any;
      properties.commFondiInterniMonetariProperty.value = "";
      properties.commFondiInterniMonetariProperty.rangeValues = [];

      if (
        selectChoices.tipoCommFondiInterniMonetari.code == "40.9" ||
        selectChoices.tipoCommFondiInterniMonetari.code == "40.10"
      ) {
        properties.commFondiInterniMonetariProperty.value = vm.getOptionDescriptionByCode(
          selectChoices.tipoCommFondiInterniMonetari.code,
          data.tipoCommFondiInterniMonetariOptions
        );
      } else if (
        selectChoices.tipoCommFondiInterniMonetari.code == "40.2" ||
        selectChoices.tipoCommFondiInterniMonetari.code == "40.3" ||
        selectChoices.tipoCommFondiInterniMonetari.code == "40.4" ||
        selectChoices.tipoCommFondiInterniMonetari.code == "40.5" ||
        selectChoices.tipoCommFondiInterniMonetari.code == "40.6" ||
        selectChoices.tipoCommFondiInterniMonetari.code == "40.7" ||
        selectChoices.tipoCommFondiInterniMonetari.code == "40.8"
      ) {
        properties.commFondiInterniMonetariProperty.rangeValues = [
          {
            order: 0,
            from: "",
            to: "",
            value: ""
          }
        ];
      }
    },
    resetCommissioneOICRProperty: function(property: any) {
      const vm = this as any;

      property.value = "";
      property.rangeValues = [];

      if (selectChoices.tipologiaCommissioneOICR.code == "42.9") {
        property.value = vm.getOptionDescriptionByCode(
          selectChoices.tipologiaCommissioneOICR.code,
          vm.tipologiaCommissioneOICROptions
        );
      } else if (
        selectChoices.tipologiaCommissioneOICR.code == "42.2" ||
        selectChoices.tipologiaCommissioneOICR.code == "42.3" ||
        selectChoices.tipologiaCommissioneOICR.code == "42.4" ||
        selectChoices.tipologiaCommissioneOICR.code == "42.5" ||
        selectChoices.tipologiaCommissioneOICR.code == "42.6" ||
        selectChoices.tipologiaCommissioneOICR.code == "42.7" ||
        selectChoices.tipologiaCommissioneOICR.code == "42.8"
      ) {
        property.rangeValues = [
          {
            order: 0,
            from: "",
            to: "",
            value: ""
          }
        ];
      }
    },
    resetCommissioneOICRProperties: function() {
      const vm = this as any;

      vm.resetCommissioneOICRProperty(properties.commissioneOICRAzionariProperty);
      vm.resetCommissioneOICRProperty(
        properties.commissioneOICRObbligazionariProperty
      );
      vm.resetCommissioneOICRProperty(properties.commissioneOICRBilanciatiProperty);
      vm.resetCommissioneOICRProperty(properties.commissioneOICRFlessibiliProperty);
      vm.resetCommissioneOICRProperty(properties.commissioneOICRMonetariProperty);
    },
    setCodProdCollegatoProperty: function() {
      const vm = this as any;
      
      if (selectChoices.prodCollegato.code == "11.2b") {
        properties.codProdCollegatoProperty.value = vm.ND;
        selectChoices.relazioneProdCollegato.code = "11d";
        selectChoices.relazioneProdCollegato.description = vm.ND;
        properties.relazioneProdCollegatoProperty.value = vm.ND;
      } else {
        properties.codProdCollegatoProperty.value = "";
        selectChoices.relazioneProdCollegato.code = "";
        selectChoices.relazioneProdCollegato.description = "";
        properties.relazioneProdCollegatoProperty.value = "";
      }
    },
    setSpeseAmministrativeVersamentoPAC: function() {
      const vm = this as any;

      if (selectChoices.tipoPremio.code == "11.1a") {
        properties.speseAmministrativeVersamentoPACProperty.value = vm.ND;
      } else {
        properties.speseAmministrativeVersamentoPACProperty.value = "";
      }
    },
    isGestioneSeparata: function() {
      const vm = this as any;
      
      return (
        selectChoices.tipoSottostanti.code != "7.2" &&
        selectChoices.tipoSottostanti.code != "7.3" &&
        selectChoices.tipoSottostanti.code != "7.4" &&
        selectChoices.tipoSottostanti.code != "7.12" &&
        selectChoices.tipoSottostanti.code != "7.13" &&
        selectChoices.tipoSottostanti.code != "7.14" &&
        selectChoices.tipoSottostanti.code != "7.15"
      );
    },
    isNDCommissioneFondiInterni: function() {
      const vm = this as any;
      
      return (
        selectChoices.tipoSottostanti.code == "7.1" ||
        selectChoices.tipoSottostanti.code == "7.3" ||
        selectChoices.tipoSottostanti.code == "7.4" ||
        selectChoices.tipoSottostanti.code == "7.6" ||
        selectChoices.tipoSottostanti.code == "7.7" ||
        selectChoices.tipoSottostanti.code == "7.11" ||
        selectChoices.tipoSottostanti.code == "7.15"
      );
    },    
    isNdOICR: function() {
      const vm = this as any;

      return (
        selectChoices.tipoSottostanti.code == "7.1" ||
        selectChoices.tipoSottostanti.code == "7.2" ||
        selectChoices.tipoSottostanti.code == "7.5"
      );
    },
    sottostantiHandler: function() {
      const vm = this as any;
      if (!vm.isGestioneSeparata()) {
        properties.retrocessioneGestSepProperty.value = vm.ND;
        properties.gsWeightMinProperty.value = vm.ND;
        properties.gsWeightMaxProperty.value = vm.ND;
        selectChoices.tipoCommGestioneSeparata.code = "30";
        selectChoices.tipoCommGestioneSeparata.description = vm.ND;
        properties.tipoCommGestioneSeparataProperty.code = "30";
        properties.tipoCommGestioneSeparataProperty.value = vm.ND;
        properties.commGestioneSeparataProperty.value = vm.ND;
        properties.commGestioneSeparataProperty.rangeValues = [];
      } else {
        properties.retrocessioneGestSepProperty.value = "";
        properties.gsWeightMinProperty.value = "";
        properties.gsWeightMaxProperty.value = "";
        selectChoices.tipoCommGestioneSeparata.code = "";
        selectChoices.tipoCommGestioneSeparata.description = "";
        properties.commGestioneSeparataProperty.value = "";
        properties.commGestioneSeparataProperty.rangeValues = [];
      }

      if (selectChoices.tipoSottostanti.code == "7.1") {
        properties.costoGaranziaMorteProperty.value = vm.ND;
        properties.retrocessioneRamIIIProperty.value = vm.ND;        
      } else {
        properties.costoGaranziaMorteProperty.value = "";
        properties.retrocessioneRamIIIProperty.value = "";
      }

      if (vm.isNDCommissioneFondiInterni()) {
        selectChoices.tipoCommFondiInterniAzionari.code = "32";
        selectChoices.tipoCommFondiInterniAzionari.description = vm.ND;
        properties.tipoCommFondiInterniAzionariProperty.code = "32";
        properties.tipoCommFondiInterniAzionariProperty.value = vm.ND;
        properties.commFondiInterniAzionariProperty.value = vm.ND;
        properties.commFondiInterniAzionariProperty.rangeValues = [];

        selectChoices.tipoCommFondiInterniObbligazionari.code = "34";
        selectChoices.tipoCommFondiInterniObbligazionari.description = vm.ND;
        properties.tipoCommFondiInterniObbligazionariProperty.code = "34";
        properties.tipoCommFondiInterniObbligazionariProperty.value = vm.ND;
        properties.commFondiInterniObbligazionariProperty.value = vm.ND;
        properties.commFondiInterniObbligazionariProperty.rangeValues = [];

        selectChoices.tipoCommFondiInterniBilanciati.code = "36";
        selectChoices.tipoCommFondiInterniBilanciati.description = vm.ND;
        properties.tipoCommFondiInterniBilanciatiProperty.code = "36";
        properties.tipoCommFondiInterniBilanciatiProperty.value = vm.ND;
        properties.commFondiInterniBilanciatiProperty.value = vm.ND;
        properties.commFondiInterniBilanciatiProperty.rangeValues = [];

        selectChoices.tipoCommFondiInterniFlessibili.code = "38";
        selectChoices.tipoCommFondiInterniFlessibili.description = vm.ND;
        properties.tipoCommFondiInterniFlessibiliProperty.code = "38";
        properties.tipoCommFondiInterniFlessibiliProperty.value = vm.ND;
        properties.commFondiInterniFlessibiliProperty.value = vm.ND;
        properties.commFondiInterniFlessibiliProperty.rangeValues = [];

        selectChoices.tipoCommFondiInterniMonetari.code = "40";
        selectChoices.tipoCommFondiInterniMonetari.description = vm.ND;
        properties.tipoCommFondiInterniMonetariProperty.code = "40";
        properties.tipoCommFondiInterniMonetariProperty.value = vm.ND;
        properties.commFondiInterniMonetariProperty.value = vm.ND;
        properties.commFondiInterniMonetariProperty.rangeValues = [];
      } else {
        selectChoices.tipoCommFondiInterniAzionari.code = "";
        selectChoices.tipoCommFondiInterniAzionari.description = "";
        properties.commFondiInterniAzionariProperty.value = "";
        properties.commFondiInterniAzionariProperty.rangeValues = [];

        selectChoices.tipoCommFondiInterniObbligazionari.code = "";
        selectChoices.tipoCommFondiInterniObbligazionari.description = "";
        properties.commFondiInterniObbligazionariProperty.value = "";
        properties.commFondiInterniObbligazionariProperty.rangeValues = [];

        selectChoices.tipoCommFondiInterniBilanciati.code = "";
        selectChoices.tipoCommFondiInterniBilanciati.description = "";
        properties.commFondiInterniBilanciatiProperty.value = "";
        properties.commFondiInterniBilanciatiProperty.rangeValues = [];

        selectChoices.tipoCommFondiInterniFlessibili.code = "";
        selectChoices.tipoCommFondiInterniFlessibili.description = "";
        properties.commFondiInterniFlessibiliProperty.value = "";
        properties.commFondiInterniFlessibiliProperty.rangeValues = [];

        selectChoices.tipoCommFondiInterniMonetari.code = "";
        selectChoices.tipoCommFondiInterniMonetari.description = "";
        properties.commFondiInterniMonetariProperty.value = "";
        properties.commFondiInterniMonetariProperty.rangeValues = [];
      }

      if (vm.isNdOICR()) {
        selectChoices.tipologiaCommissioneOICR.code = "42";
        selectChoices.tipologiaCommissioneOICR.description = vm.ND;
        properties.tipologiaCommissioneOICRProperty.code = "42";
        properties.tipologiaCommissioneOICRProperty.value = vm.ND;

        properties.commissioneOICRAzionariProperty.value = vm.ND;
        properties.commissioneOICRAzionariProperty.rangeValues = [];

        properties.commissioneOICRObbligazionariProperty.value = vm.ND;
        properties.commissioneOICRObbligazionariProperty.rangeValues = [];

        properties.commissioneOICRBilanciatiProperty.value = vm.ND;
        properties.commissioneOICRBilanciatiProperty.rangeValues = [];

        properties.commissioneOICRFlessibiliProperty.value = vm.ND;
        properties.commissioneOICRFlessibiliProperty.rangeValues = [];

        properties.commissioneOICRMonetariProperty.value = vm.ND;
        properties.commissioneOICRMonetariProperty.rangeValues = [];
      } else {
        selectChoices.tipologiaCommissioneOICR.code = "";
        selectChoices.tipologiaCommissioneOICR.description = "";

        properties.commissioneOICRAzionariProperty.value = "";
        properties.commissioneOICRAzionariProperty.rangeValues = [];

        properties.commissioneOICRObbligazionariProperty.value = "";
        properties.commissioneOICRObbligazionariProperty.rangeValues = [];

        properties.commissioneOICRBilanciatiProperty.value = "";
        properties.commissioneOICRBilanciatiProperty.rangeValues = [];

        properties.commissioneOICRFlessibiliProperty.value = "";
        properties.commissioneOICRFlessibiliProperty.rangeValues = [];

        properties.commissioneOICRMonetariProperty.value = "";
        properties.commissioneOICRMonetariProperty.rangeValues = [];
      }      
    },
    checkFields: function() {
      const vm = this as any;

      let numErr = 0;

      vm.errorMsg = null;
      vm.okMsg = null;
      if (
        properties.nomeProperty.value == undefined ||
        properties.nomeProperty.value == null ||
        properties.nomeProperty.value == ""
      ) {
        vm.errorMsg =
          "Il campo " + properties.nomeProperty.name + " deve essere valorizzato";
        numErr++;
      }

      let retValue = true;
      if (numErr > 0) {
        retValue = false;
      } else {
        vm.okMsg = "Prodotto " + properties.nomeProperty.value + " registrato";
      }

      return retValue;
    },
    formatDate: function(data: Date | string) {
      if (typeof data === "string" || isNil(data)) {
        return "";
      }

      return format(data, "dd/MM/yyyy");
    },
    dateFromString: function(value: string | Date) {
      if (typeof value !== "string" || isNil(value)) {
        return null;
      }

      const parts = value.split("/");
      if (parts.length == 3) {
        const dt = parts[1] + "/" + parts[0] + "/" + parts[2];

        const timestamp = Date.parse(dt);
        if (isNaN(timestamp) == false) {
          return new Date(timestamp);
        }
      }

      return null;
    },
    setDatePropertiesValue: function() {
      const vm = this as any;

      properties.edizioneProperty.value = vm.formatDate(properties.edizioneProperty.dateValue);
      properties.inizioCommProperty.value = vm.formatDate(properties.inizioCommProperty.dateValue);
      if (properties.prodCommProperty.code == "9.2") {
        properties.fineCommProperty.value = vm.formatDate(properties.fineCommProperty.dateValue);
      }
      if (properties.tipologiaDurationProperty.code == "13.2") {
        properties.dataScadenzaProperty.value = vm.formatDate(properties.dataScadenzaProperty.dateValue);
      }
    },
    setPropertiesType: function() {
      const vm = this as any;

      //dataScadenzaProperty
      if (properties.tipologiaDurationProperty.code == "" ||
          properties.tipologiaDurationProperty.code == "13" ||
          properties.tipologiaDurationProperty.code == "13.1") {
        properties.dataScadenzaProperty.type = propertyTypes.STRING;
      } else if (properties.tipologiaDurationProperty.code == "13.2") {
        properties.dataScadenzaProperty.type = propertyTypes.DATE;
      } else if (properties.tipologiaDurationProperty.code == "13.3") {
        properties.dataScadenzaProperty.type = propertyTypes.STRING;
      } else if (properties.tipologiaDurationProperty.code == "13.4") {
        properties.dataScadenzaProperty.type = propertyTypes.RANGE;
      } else if (properties.tipologiaDurationProperty.code == "13.5") {
        properties.dataScadenzaProperty.type = propertyTypes.STRING;
      }

      //bonusIngressoProperty
      if (properties.tipoCalcoloBonusIngressoProperty.code == "" ||
          properties.tipoCalcoloBonusIngressoProperty.code == "22" ||
          properties.tipoCalcoloBonusIngressoProperty.code == "22.1" ||
          properties.tipoCalcoloBonusIngressoProperty.code == "22.6" ||
          properties.tipoCalcoloBonusIngressoProperty.code == "22.7") {
        properties.bonusIngressoProperty.type = propertyTypes.STRING;
      } else {
        properties.bonusIngressoProperty.type = propertyTypes.NUMBER_RANGE;
      }

      //bonusFedeltaProperty
      if (properties.tipoCalcoloBonusFedeltaProperty.code == "" ||
          properties.tipoCalcoloBonusFedeltaProperty.code == "24" ||
          properties.tipoCalcoloBonusFedeltaProperty.code == "24.3" ||
          properties.tipoCalcoloBonusFedeltaProperty.code == "24.4") {
        properties.bonusFedeltaProperty.type = propertyTypes.STRING;
      } else {
        properties.bonusFedeltaProperty.type = propertyTypes.RANGE;
      }

      //upfrontFeeRangeProperty
      if (properties.tipologiaUpfrontFeeProperty.code == "" ||
          properties.tipologiaUpfrontFeeProperty.code == "28" ||
          properties.tipologiaUpfrontFeeProperty.code == "28.1" ||
          properties.tipologiaUpfrontFeeProperty.code == "28.11" ||
          properties.tipologiaUpfrontFeeProperty.code == "28.12") {
        properties.upfrontFeeRangeProperty.type = propertyTypes.STRING;
      } else if (properties.tipologiaUpfrontFeeProperty.code == "28.6" ||
          properties.tipologiaUpfrontFeeProperty.code == "28.7" ||
          properties.tipologiaUpfrontFeeProperty.code == "28.8" ||
          properties.tipologiaUpfrontFeeProperty.code == "28.10") {
        properties.upfrontFeeRangeProperty.type = propertyTypes.TIME_NUMBER_RANGE;
      } else if (properties.tipologiaUpfrontFeeProperty.code == "28.2" ||
          properties.tipologiaUpfrontFeeProperty.code == "28.3" ||
          properties.tipologiaUpfrontFeeProperty.code == "28.4" ||
          properties.tipologiaUpfrontFeeProperty.code == "28.9") {
        properties.upfrontFeeRangeProperty.type = propertyTypes.NUMBER_RANGE;
      } else if (properties.tipologiaUpfrontFeeProperty.code == "28.5") {
        properties.upfrontFeeRangeProperty.type = propertyTypes.TIME_RANGE;
      }

      //commGestioneSeparataProperty
      if (properties.tipoCommGestioneSeparataProperty.code == "" ||
          properties.tipoCommGestioneSeparataProperty.code == "30" ||
          properties.tipoCommGestioneSeparataProperty.code == "30.1" ||
          properties.tipoCommGestioneSeparataProperty.code == "30.9" ||
          properties.tipoCommGestioneSeparataProperty.code == "30.10") {
        properties.commGestioneSeparataProperty.type = propertyTypes.STRING;
      } else if (properties.tipoCommGestioneSeparataProperty.code == "30.5" ||
          properties.tipoCommGestioneSeparataProperty.code == "30.6" ||
          properties.tipoCommGestioneSeparataProperty.code == "30.8") {
        properties.commGestioneSeparataProperty.type = propertyTypes.TIME_NUMBER_RANGE;
      } else if (properties.tipoCommGestioneSeparataProperty.code == "30.2" ||
          properties.tipoCommGestioneSeparataProperty.code == "30.3" ||
          properties.tipoCommGestioneSeparataProperty.code == "30.7") {
        properties.commGestioneSeparataProperty.type = propertyTypes.NUMBER_RANGE;
      } else if (properties.tipoCommGestioneSeparataProperty.code == "30.4") {
        properties.commGestioneSeparataProperty.type = propertyTypes.TIME_RANGE;
      }

      //commFondiInterniAzionariProperty
      if (properties.tipoCommFondiInterniAzionariProperty.code == "" ||
          properties.tipoCommFondiInterniAzionariProperty.code == "32" ||
          properties.tipoCommFondiInterniAzionariProperty.code == "32.1" ||
          properties.tipoCommFondiInterniAzionariProperty.code == "32.9" ||
          properties.tipoCommFondiInterniAzionariProperty.code == "32.10") {
        properties.commFondiInterniAzionariProperty.type = propertyTypes.STRING;
      } else if (properties.tipoCommFondiInterniAzionariProperty.code == "32.5" ||
          properties.tipoCommFondiInterniAzionariProperty.code == "32.6" ||
          properties.tipoCommFondiInterniAzionariProperty.code == "32.8") {
        properties.commFondiInterniAzionariProperty.type = propertyTypes.TIME_NUMBER_RANGE;
      } else if (properties.tipoCommFondiInterniAzionariProperty.code == "32.2" ||
          properties.tipoCommFondiInterniAzionariProperty.code == "32.3" ||
          properties.tipoCommFondiInterniAzionariProperty.code == "32.7") {
        properties.commFondiInterniAzionariProperty.type = propertyTypes.NUMBER_RANGE;
      } else if (properties.tipoCommFondiInterniAzionariProperty.code == "32.4") {
        properties.commFondiInterniAzionariProperty.type = propertyTypes.TIME_RANGE;
      }

      //commFondiInterniObbligazionariProperty
      if (properties.tipoCommFondiInterniObbligazionariProperty.code == "" ||
          properties.tipoCommFondiInterniObbligazionariProperty.code == "34" ||
          properties.tipoCommFondiInterniObbligazionariProperty.code == "34.1" ||
          properties.tipoCommFondiInterniObbligazionariProperty.code == "34.9" ||
          properties.tipoCommFondiInterniObbligazionariProperty.code == "34.10") {
        properties.commFondiInterniObbligazionariProperty.type = propertyTypes.STRING;
      } else if (properties.tipoCommFondiInterniObbligazionariProperty.code == "34.5" ||
          properties.tipoCommFondiInterniObbligazionariProperty.code == "34.6" ||
          properties.tipoCommFondiInterniObbligazionariProperty.code == "34.8") {
        properties.commFondiInterniObbligazionariProperty.type = propertyTypes.TIME_NUMBER_RANGE;
      } else if (properties.tipoCommFondiInterniObbligazionariProperty.code == "34.2" ||
          properties.tipoCommFondiInterniObbligazionariProperty.code == "34.3" ||
          properties.tipoCommFondiInterniObbligazionariProperty.code == "34.7") {
        properties.commFondiInterniObbligazionariProperty.type = propertyTypes.NUMBER_RANGE;
      } else if (properties.tipoCommFondiInterniObbligazionariProperty.code == "34.4") {
        properties.commFondiInterniObbligazionariProperty.type = propertyTypes.TIME_RANGE;
      }

      //commFondiInterniBilanciatiProperty
      if (properties.tipoCommFondiInterniBilanciatiProperty.code == "" ||
          properties.tipoCommFondiInterniBilanciatiProperty.code == "36" ||
          properties.tipoCommFondiInterniBilanciatiProperty.code == "36.1" ||
          properties.tipoCommFondiInterniBilanciatiProperty.code == "36.9" ||
          properties.tipoCommFondiInterniBilanciatiProperty.code == "36.10") {
        properties.commFondiInterniBilanciatiProperty.type = propertyTypes.STRING;
      } else if (properties.tipoCommFondiInterniBilanciatiProperty.code == "36.5" ||
          properties.tipoCommFondiInterniBilanciatiProperty.code == "36.6" ||
          properties.tipoCommFondiInterniBilanciatiProperty.code == "36.8") {
        properties.commFondiInterniBilanciatiProperty.type = propertyTypes.TIME_NUMBER_RANGE;
      } else if (properties.tipoCommFondiInterniBilanciatiProperty.code == "36.2" ||
          properties.tipoCommFondiInterniBilanciatiProperty.code == "36.3" ||
          properties.tipoCommFondiInterniBilanciatiProperty.code == "36.7") {
        properties.commFondiInterniBilanciatiProperty.type = propertyTypes.NUMBER_RANGE;
      } else if (properties.tipoCommFondiInterniBilanciatiProperty.code == "36.4") {
        properties.commFondiInterniBilanciatiProperty.type = propertyTypes.TIME_RANGE;
      }

      //commFondiInterniFlessibiliProperty
      if (properties.tipoCommFondiInterniFlessibiliProperty.code == "" ||
          properties.tipoCommFondiInterniFlessibiliProperty.code == "38" ||
          properties.tipoCommFondiInterniFlessibiliProperty.code == "38.1" ||
          properties.tipoCommFondiInterniFlessibiliProperty.code == "38.9" ||
          properties.tipoCommFondiInterniFlessibiliProperty.code == "38.10") {
        properties.commFondiInterniFlessibiliProperty.type = propertyTypes.STRING;
      } else if (properties.tipoCommFondiInterniFlessibiliProperty.code == "38.5" ||
          properties.tipoCommFondiInterniFlessibiliProperty.code == "38.6" ||
          properties.tipoCommFondiInterniFlessibiliProperty.code == "38.8") {
        properties.commFondiInterniFlessibiliProperty.type = propertyTypes.TIME_NUMBER_RANGE;
      } else if (properties.tipoCommFondiInterniFlessibiliProperty.code == "38.2" ||
          properties.tipoCommFondiInterniFlessibiliProperty.code == "38.3" ||
          properties.tipoCommFondiInterniFlessibiliProperty.code == "38.7"){
        properties.commFondiInterniFlessibiliProperty.type = propertyTypes.NUMBER_RANGE;
      } else if (properties.tipoCommFondiInterniFlessibiliProperty.code == "38.4"){
        properties.commFondiInterniFlessibiliProperty.type = propertyTypes.TIME_RANGE;
      }

      //commFondiInterniMonetariProperty
      if (properties.tipoCommFondiInterniMonetariProperty.code == "40" ||
          properties.tipoCommFondiInterniMonetariProperty.code == "40.1" ||
          properties.tipoCommFondiInterniMonetariProperty.code == "40.9" ||
          properties.tipoCommFondiInterniMonetariProperty.code == "40.10") {
        properties.commFondiInterniMonetariProperty.type = propertyTypes.STRING;
      } else if (properties.tipoCommFondiInterniMonetariProperty.code == "40.5" ||
          properties.tipoCommFondiInterniMonetariProperty.code == "40.6" ||
          properties.tipoCommFondiInterniMonetariProperty.code == "40.8") {
        properties.commFondiInterniMonetariProperty.type = propertyTypes.TIME_NUMBER_RANGE;
      } else if (properties.tipoCommFondiInterniMonetariProperty.code == "40.2" ||
          properties.tipoCommFondiInterniMonetariProperty.code == "40.3" ||
          properties.tipoCommFondiInterniMonetariProperty.code == "40.7") {
        properties.commFondiInterniMonetariProperty.type = propertyTypes.NUMBER_RANGE;
      } else if (properties.tipoCommFondiInterniMonetariProperty.code == "40.4") {
        properties.commFondiInterniMonetariProperty.type = propertyTypes.TIME_RANGE;
      }

      //commissioneOICRAzionariProperty, ...
      if (properties.tipologiaCommissioneOICRProperty.code == "" ||
          properties.tipologiaCommissioneOICRProperty.code == "42" ||
          properties.tipologiaCommissioneOICRProperty.code == "42.1" ||
          properties.tipologiaCommissioneOICRProperty.code == "42.9") {
        properties.commissioneOICRAzionariProperty.type = propertyTypes.STRING;
        properties.commissioneOICRObbligazionariProperty.type = propertyTypes.STRING;
        properties.commissioneOICRBilanciatiProperty.type = propertyTypes.STRING;
        properties.commissioneOICRFlessibiliProperty.type = propertyTypes.STRING;
        properties.commissioneOICRMonetariProperty.type = propertyTypes.STRING;
      } else if (properties.tipologiaCommissioneOICRProperty.code == "42.5" ||
          properties.tipologiaCommissioneOICRProperty.code == "42.6" ||
          properties.tipologiaCommissioneOICRProperty.code == "42.8") {
        properties.commissioneOICRAzionariProperty.type = propertyTypes.TIME_NUMBER_RANGE;
        properties.commissioneOICRObbligazionariProperty.type = propertyTypes.TIME_NUMBER_RANGE;
        properties.commissioneOICRBilanciatiProperty.type = propertyTypes.TIME_NUMBER_RANGE;
        properties.commissioneOICRFlessibiliProperty.type = propertyTypes.TIME_NUMBER_RANGE;
        properties.commissioneOICRMonetariProperty.type = propertyTypes.TIME_NUMBER_RANGE;            
      } else if (properties.tipologiaCommissioneOICRProperty.code == "42.2" ||
          properties.tipologiaCommissioneOICRProperty.code == "42.3" ||
          properties.tipologiaCommissioneOICRProperty.code == "42.7") {
        properties.commissioneOICRAzionariProperty.type = propertyTypes.NUMBER_RANGE;
        properties.commissioneOICRObbligazionariProperty.type = propertyTypes.NUMBER_RANGE;
        properties.commissioneOICRBilanciatiProperty.type = propertyTypes.NUMBER_RANGE;
        properties.commissioneOICRFlessibiliProperty.type = propertyTypes.NUMBER_RANGE;
        properties.commissioneOICRMonetariProperty.type = propertyTypes.NUMBER_RANGE;            
      } else if (properties.tipologiaCommissioneOICRProperty.code == "42.4") {
        properties.commissioneOICRAzionariProperty.type = propertyTypes.TIME_RANGE;
        properties.commissioneOICRObbligazionariProperty.type = propertyTypes.TIME_RANGE;
        properties.commissioneOICRBilanciatiProperty.type = propertyTypes.TIME_RANGE;
        properties.commissioneOICRFlessibiliProperty.type = propertyTypes.TIME_RANGE;
        properties.commissioneOICRMonetariProperty.type = propertyTypes.TIME_RANGE;
      }

      //commissioneUscitaProperty
      if (properties.applicazioneCommissioniUscitaProperty.code == "" ||
          properties.applicazioneCommissioniUscitaProperty.code == "50" ||
          properties.applicazioneCommissioniUscitaProperty.code == "50.2" ||
          properties.applicazioneCommissioniUscitaProperty.code == "50.3") {
        properties.commissioneUscitaProperty.type = propertyTypes.STRING;
      } else {
        properties.commissioneUscitaProperty.type = propertyTypes.TIME_RANGE;
      }

      //scenarioKIDStressProperty, ...
      if (properties.KIDProperty.code == "52.1") {
        properties.scenarioKIDStressProperty.type = propertyTypes.KID;
        properties.scenarioKIDSfavorevoleProperty.type = propertyTypes.KID;
        properties.scenarioKIDModeratoProperty.type = propertyTypes.KID;
        properties.scenarioKIDFavorevoleProperty.type = propertyTypes.KID;
        properties.scenarioKIDCasoMorteProperty.type = propertyTypes.KID;
      } else if (properties.KIDProperty.code == "" ||
                 properties.KIDProperty.code == "52" ||
                 properties.KIDProperty.code == "52.2") { //n.d.
        properties.scenarioKIDStressProperty.type = propertyTypes.STRING;
        properties.scenarioKIDSfavorevoleProperty.type = propertyTypes.STRING;
        properties.scenarioKIDModeratoProperty.type = propertyTypes.STRING;
        properties.scenarioKIDFavorevoleProperty.type = propertyTypes.STRING;
        properties.scenarioKIDCasoMorteProperty.type = propertyTypes.STRING;
      }

      //GKIDProperty, ...
      if (properties.GKIDProperty.code == "58") {
        const costs1 = properties.GKIDProperty.gkid.costs[0] as any;
        const costs2 = properties.GKIDProperty.gkid.costs[1] as any;
        const costs3 = properties.GKIDProperty.gkid.costs[2] as any;
        if (costs1.from == "" && costs1.to == "" &&
            costs2.from == "" && costs2.to == "" &&
            costs3.from == "" && costs3.to == "" &&
            properties.GKIDProperty.gkid.risk.from == "" &&
            properties.GKIDProperty.gkid.risk.to == ""
        ) {
          properties.GKIDProperty.type = propertyTypes.STRING;
        }
      }

    },
    setPropertiesDefaultCode: function () {
      if (properties.mercatoProperty.code == "") { properties.mercatoProperty.code = "4a"; }
      if (properties.destinatariProperty.code == "") { properties.destinatariProperty.code = "4b"; }
      if (properties.canaleProperty.code == "") { properties.canaleProperty.code = "5"; }
      if (properties.tipoProdottoProperty.code == "") { properties.tipoProdottoProperty.code = "6"; }
      if (properties.tipoSottostantiProperty.code == "") { properties.tipoSottostantiProperty.code = "7"; }
      if (properties.prodCommProperty.code == "") { properties.prodCommProperty.code = "9"; }
      if (properties.tipoPremioProperty.code == "") { properties.tipoPremioProperty.code = "11a"; }
      if (properties.prodCollegatoProperty.code == "") { properties.prodCollegatoProperty.code = "11b"; }
      if (properties.relazioneProdCollegatoProperty.code == "") { properties.relazioneProdCollegatoProperty.code = "11d"; }
      if (properties.tipologiaDurationProperty.code == "") { properties.tipologiaDurationProperty.code = "13"; }
      if (properties.tipoCalcoloBonusIngressoProperty.code == "") { properties.tipoCalcoloBonusIngressoProperty.code = "22"; }
      if (properties.tipoCalcoloBonusFedeltaProperty.code == "") { properties.tipoCalcoloBonusFedeltaProperty.code = "24"; }
      if (properties.tipologiaUpfrontFeeProperty.code == "") { properties.tipologiaUpfrontFeeProperty.code = "28"; }
      if (properties.tipoCommGestioneSeparataProperty.code == "") { properties.tipoCommGestioneSeparataProperty.code = "30"; }
      if (properties.tipoCommFondiInterniAzionariProperty.code == "") { properties.tipoCommFondiInterniAzionariProperty.code = "32"; }
      if (properties.tipoCommFondiInterniObbligazionariProperty.code == "") { properties.tipoCommFondiInterniObbligazionariProperty.code = "34"; }
      if (properties.tipoCommFondiInterniBilanciatiProperty.code == "") { properties.tipoCommFondiInterniBilanciatiProperty.code = "36"; }
      if (properties.tipoCommFondiInterniFlessibiliProperty.code == "") { properties.tipoCommFondiInterniFlessibiliProperty.code = "38"; }
      if (properties.tipoCommFondiInterniMonetariProperty.code == "") { properties.tipoCommFondiInterniMonetariProperty.code = "40"; }
      if (properties.tipologiaCommissioneOICRProperty.code == "") { properties.tipologiaCommissioneOICRProperty.code = "42"; }
      if (properties.commissioniOverperformanceProperty.code == "") { properties.commissioniOverperformanceProperty.code = "48"; }
      if (properties.applicazioneCommissioniUscitaProperty.code == "") { properties.applicazioneCommissioniUscitaProperty.code = "50"; }
      if (properties.KIDProperty.code == "") { properties.KIDProperty.code = "52"; }
    },
    prefillProperties: async function() {
      const vm = this as any;
      
      // se si arriva da Database.vue bisogna prefillare i campi
      if (vm.productIdSelected != undefined) {
        vm.startLoading();

        const serviceCallReturnValue = await requestService
          .getProduct(vm.productIdSelected)
          .then(handleResponse)
          .then((result: any) => {
            const nome = result.properties[0].value;
            const emittente = result.properties[1].value;
            const distributore = result.properties[2].value;
            const mercatoCode = result.properties[3].code;
            const mercatoValue = result.properties[3].value;
            const destinatariCode = result.properties[4].code;
            const destinatariValue = result.properties[4].value;
            const canaleCode = result.properties[5].code;
            const canaleValue = result.properties[5].value;
            const tipoProdottoCode = result.properties[6].code;
            const tipoProdottoValue = result.properties[6].value;
            const tipoSottostantiCode = result.properties[7].code;
            const tipoSottostantiValue = result.properties[7].value;
            const edizione = result.properties[8].value;
            const inCommercioCode = result.properties[9].code;
            const inCommercioValue = result.properties[9].value;
            const inizioComm = result.properties[10].value;
            const fineComm = result.properties[11].value;
            const tipoPremioCode = result.properties[12].code;
            const tipoPremioValue = result.properties[12].value;
            const prodCollCode = result.properties[13].code;
            const prodCollValue = result.properties[13].value;
            const codProdColl = result.properties[14].value;
            const relazioneProdCollCode = result.properties[15].code;
            const relazioneProdCollValue = result.properties[15].value;
            const orizzonteTemporale = result.properties[16].value;
            const tipoDurationCode = result.properties[17].code;
            const tipoDurationValue = result.properties[17].value;
            const dataScadenzaValue = result.properties[18].value;
            const dataScadenzaRangeValues = result.properties[18].rangeValues;
            const impMinimoValue = result.properties[19].value;
            const impMassimoValue = result.properties[20].value;
            const retrocessioneUpfrontValue = result.properties[21].value;
            const retrocessioneGestSepValue = result.properties[22].value;
            const retrocessioneRamIIIValue = result.properties[23].value;
            const gsWeightMinValue = result.properties[24].value;
            const gsWeightMaxValue = result.properties[25].value;
            const tipoCalcoloBonusIngressoCode = result.properties[26].code;
            const tipoCalcoloBonusIngressoValue = result.properties[26].value;
            const bonusIngressoValue = result.properties[27].value;
            const bonusIngressoRangeValues = result.properties[27].rangeValues;
            const tipoCalcoloBonusFedeltaCode = result.properties[28].code;
            const tipoCalcoloBonusFedeltaValue = result.properties[28].value;
            const bonusFedeltaValue = result.properties[29].value;
            const bonusFedeltaRangeValues = result.properties[29].rangeValues;
            const speseAmmAperturaValue = result.properties[30].value;
            const speseAmmVersamentoValue = result.properties[31].value;
            const tipoUpfrontFeeCode = result.properties[32].code;
            const tipoUpfrontFeeValue = result.properties[32].value;
            const upfrontFeeValue = result.properties[33].value;
            const upfrontFeeRangeValues = result.properties[33].rangeValues;
            const tipoCommGestioneSeparataCode = result.properties[34].code;
            const tipoCommGestioneSeparataValue = result.properties[34].value;
            const commGestioneSeparataValue = result.properties[35].value;
            const commGestioneSeparataRangeValues = result.properties[35].rangeValues;
            const tipoCommFIAzCode = result.properties[36].code;
            const tipoCommFIAzValue = result.properties[36].value;
            const tipoCommFIObblCode = result.properties[37].code;
            const tipoCommFIObblValue = result.properties[37].value;
            const tipoCommFIBilCode = result.properties[38].code;
            const tipoCommFIBilValue = result.properties[38].value;
            const tipoCommFIFleCode = result.properties[39].code;
            const tipoCommFIFleValue = result.properties[39].value;
            const tipoCommFIMonCode = result.properties[40].code;
            const tipoCommFIMonValue = result.properties[40].value;
            const commFIAzValue = result.properties[41].value;
            const commFIAzRangeValues = result.properties[41].rangeValues;
            const commFIObblValue = result.properties[42].value;
            const commFIObblRangeValues = result.properties[42].rangeValues;
            const commFIBilValue = result.properties[43].value;
            const commFIBilRangeValues = result.properties[43].rangeValues;
            const commFIFleValue = result.properties[44].value;
            const commFIFleRangeValues = result.properties[44].rangeValues;
            const commFIMonValue = result.properties[45].value;
            const commFIMonRangeValues = result.properties[45].rangeValues;
            const tipoCommOICRCode = result.properties[46].code;
            const tipoCommOICRValue = result.properties[46].value;
            const commOICRAzValue = result.properties[47].value;
            const commOICRAzRangeValues = result.properties[47].rangeValues;
            const commOICRObblValue = result.properties[48].value;
            const commOICRObblRangeValues = result.properties[48].rangeValues;
            const commOICRBilValue = result.properties[49].value;
            const commOICRBilRangeValues = result.properties[49].rangeValues;
            const commOICRFleValue = result.properties[50].value;
            const commOICRFleRangeValues = result.properties[50].rangeValues;
            const commOICRMonValue = result.properties[51].value;
            const commOICRMonRangeValues = result.properties[51].rangeValues;
            const commOverperformanceCode = result.properties[52].code;
            const commOverperformanceValue = result.properties[52].value;
            const costoGarCasoMorteRamo3Value = result.properties[53].value;
            const applCommUscitaCode = result.properties[54].code;
            const applCommUscitaValue = result.properties[54].value;
            const commUscitaValue = result.properties[55].value;
            const commUscitaRangeValues = result.properties[55].rangeValues;
            const kidCode = result.properties[56].code;
            const kidValue = result.properties[56].value;
            const kidStressValue = result.properties[57].value;
            const kidStressRangeValues = result.properties[57].rangeValues;
            const kidSfavorevoleValue = result.properties[58].value;
            const kidSfavorevoleRangeValues = result.properties[58].rangeValues;
            const kidModeratoValue = result.properties[59].value;
            const kidModeratoRangeValues = result.properties[59].rangeValues;
            const kidFavorevoleValue = result.properties[60].value;
            const kidFavorevoleRangeValues = result.properties[60].rangeValues;
            const kidMorteValue = result.properties[61].value;
            const kidMorteRangeValues = result.properties[61].rangeValues;
            const gkidValue = result.properties[62].gkid;
            const campoNoteValue = result.properties[63].value;

            properties.nomeProperty.value = nome;
            properties.emittenteProperty.value = emittente;
            properties.distributoreProperty.value = distributore;
            properties.mercatoProperty.code = mercatoCode;
            properties.mercatoProperty.value = mercatoValue;
            if (mercatoCode.match(/\./)) {
              const v = vm.mercatoOptions.find((o: any) => o.code === mercatoCode);
              selectChoices.mercato = { code: mercatoCode, description: v ? v.description : mercatoValue };
            } else {
              selectChoices.mercato = { code: '', description: '' };
            }
            properties.destinatariProperty.code = destinatariCode;
            properties.destinatariProperty.value = destinatariValue;
            if (destinatariCode.match(/\./)) {
              const v = vm.destinatariOptions.find((o: any) => o.code === destinatariCode);
              selectChoices.destinatari = { code: destinatariCode, description: v ? v.description : destinatariValue };
            } else {
              selectChoices.destinatari = { code: '', description: '' };
            }
            properties.canaleProperty.code = canaleCode;
            properties.canaleProperty.value = canaleValue;
            if (canaleCode.match(/\./)) {
              const v = vm.canaleOptions.find((o: any) => o.code === canaleCode);
              selectChoices.canale = { code: canaleCode, description: v ? v.description : canaleValue };
            } else {
              selectChoices.canale = { code: '', description: '' };
            }
            properties.tipoProdottoProperty.code = tipoProdottoCode;
            properties.tipoProdottoProperty.value = tipoProdottoValue;
            if (tipoProdottoCode.match(/\./)) {
              const v = vm.tipoProdottoOptions.find((o: any) => o.code === tipoProdottoCode);
              selectChoices.tipoProdotto = { code: tipoProdottoCode, description: v ? v.description : tipoProdottoValue };
            } else {
              selectChoices.tipoProdotto = { code: '', description: '' };
            }
            properties.tipoSottostantiProperty.code = tipoSottostantiCode;
            properties.tipoSottostantiProperty.value = tipoSottostantiValue;
            if (tipoSottostantiCode.match(/\./)) {
              const v = vm.tipoSottostantiOptions.find((o: any) => o.code === tipoSottostantiCode);
              selectChoices.tipoSottostanti = { code: tipoSottostantiCode, description: v ? v.description : tipoSottostantiValue };
              //vm.sottostantiHandler();
            } else {
              selectChoices.tipoSottostanti = { code: '', description: '' };
            }
            properties.edizioneProperty.value = edizione;
            properties.edizioneProperty.dateValue = vm.dateFromString(edizione);
            properties.prodCommProperty.code = inCommercioCode;
            properties.prodCommProperty.value = inCommercioValue;
            if (inCommercioCode.match(/\./)) {
              const v = vm.prodCommOptions.find((o: any) => o.code === inCommercioCode);
              selectChoices.prodComm = { code: inCommercioCode, description: v ? v.description : inCommercioValue };
            } else {
              selectChoices.prodComm = { code: '', description: '' };
            }
            properties.inizioCommProperty.value = inizioComm;
            properties.inizioCommProperty.dateValue = vm.dateFromString(inizioComm);
            properties.fineCommProperty.value = fineComm;
            properties.fineCommProperty.dateValue = vm.dateFromString(fineComm);
            properties.tipoPremioProperty.code = tipoPremioCode;
            properties.tipoPremioProperty.value = tipoPremioValue;
            if (tipoPremioCode.match(/\./)) {
              const v = vm.tipoPremioOptions.find((o: any) => o.code === tipoPremioCode);
              selectChoices.tipoPremio = { code: tipoPremioCode, description: v ? v.description : tipoPremioValue };
            } else {
              selectChoices.tipoPremio = { code: '', description: '' };
            }
            properties.prodCollegatoProperty.code = prodCollCode;
            properties.prodCollegatoProperty.value = prodCollValue;
            if (prodCollCode.match(/\./)) {
              const v = vm.prodCollegatoOptions.find((o: any) => o.code === prodCollCode);
              selectChoices.prodCollegato = { code: prodCollCode, description: v ? v.description : prodCollValue };
            } else {
              selectChoices.prodCollegato = { code: '', description: '' };
            }
            properties.codProdCollegatoProperty.value = codProdColl;
            properties.relazioneProdCollegatoProperty.code = relazioneProdCollCode;
            properties.relazioneProdCollegatoProperty.value = relazioneProdCollValue;
            if (relazioneProdCollCode.match(/\./)) {
              const v = vm.relazioneProdCollegatoOptions.find((o: any) => o.code === relazioneProdCollCode);
              selectChoices.relazioneProdCollegato = { code: relazioneProdCollCode, description: v ? v.description : relazioneProdCollValue };
            } else {
              selectChoices.relazioneProdCollegato = { code: '', description: '' };
            }
            properties.orizzonteTemporaleProperty.value = orizzonteTemporale;
            properties.tipologiaDurationProperty.code = tipoDurationCode;
            properties.tipologiaDurationProperty.value = tipoDurationValue;
            if (tipoDurationCode.match(/\./)) {
              const v = vm.tipologiaDurationOptions.find((o: any) => o.code === tipoDurationCode);
              selectChoices.tipologiaDuration = { code: tipoDurationCode, description: v ? v.description : tipoDurationValue };
              //vm.resetDataScadenzaProperty();
            } else {
              selectChoices.tipologiaDuration = { code: '', description: '' };
            }
            properties.dataScadenzaProperty.value = dataScadenzaValue;
            properties.dataScadenzaProperty.dateValue = vm.dateFromString(dataScadenzaValue);
            properties.dataScadenzaProperty.rangeValues = dataScadenzaRangeValues;
            properties.importoMinimoProperty.value = impMinimoValue;
            properties.importoMassimoProperty.value = impMassimoValue;
            properties.retrocessioneUpfrontProperty.value = retrocessioneUpfrontValue;
            properties.retrocessioneGestSepProperty.value = retrocessioneGestSepValue;
            properties.retrocessioneRamIIIProperty.value = retrocessioneRamIIIValue;
            properties.gsWeightMinProperty.value = gsWeightMinValue;
            properties.gsWeightMaxProperty.value = gsWeightMaxValue;
            properties.tipoCalcoloBonusIngressoProperty.code = tipoCalcoloBonusIngressoCode;
            properties.tipoCalcoloBonusIngressoProperty.value = tipoCalcoloBonusIngressoValue;
            if (tipoCalcoloBonusIngressoCode.match(/\./)) {
              const v = vm.tipoCalcoloBonusIngressoOptions.find((o: any) => o.code === tipoCalcoloBonusIngressoCode);
              selectChoices.tipoCalcoloBonusIngresso = { code: tipoCalcoloBonusIngressoCode, description: v ? v.description : tipoCalcoloBonusIngressoValue };
              //vm.resetBonusIngressoProperty();
            } else {
              selectChoices.tipoCalcoloBonusIngresso = { code: '', description: '' };
            }
            properties.bonusIngressoProperty.value = bonusIngressoValue;
            properties.bonusIngressoProperty.rangeValues = bonusIngressoRangeValues;
            properties.tipoCalcoloBonusFedeltaProperty.code = tipoCalcoloBonusFedeltaCode;
            properties.tipoCalcoloBonusFedeltaProperty.value = tipoCalcoloBonusFedeltaValue;
            if (tipoCalcoloBonusFedeltaCode.match(/\./)) {
              const v = vm.tipoCalcoloBonusFedeltaOptions.find((o: any) => o.code === tipoCalcoloBonusFedeltaCode);
              selectChoices.tipoCalcoloBonusFedelta = { code: tipoCalcoloBonusFedeltaCode, description: v ? v.description : tipoCalcoloBonusFedeltaValue };
              //vm.resetBonusFedeltaProperty();
            } else {
              selectChoices.tipoCalcoloBonusFedelta = { code: '', description: '' };
            }
            properties.bonusFedeltaProperty.value = bonusFedeltaValue;
            properties.bonusFedeltaProperty.rangeValues = bonusFedeltaRangeValues;
            properties.speseAmministrativeAperturaContrattoProperty.value = speseAmmAperturaValue;
            properties.speseAmministrativeVersamentoPACProperty.value = speseAmmVersamentoValue;
            properties.tipologiaUpfrontFeeProperty.code = tipoUpfrontFeeCode;
            properties.tipologiaUpfrontFeeProperty.value = tipoUpfrontFeeValue;
            if (tipoUpfrontFeeCode.match(/\./)) {
              const v = vm.tipologiaUpfrontFeeOptions.find((o: any) => o.code === tipoUpfrontFeeCode);
              selectChoices.tipologiaUpfrontFee = { code: tipoUpfrontFeeCode, description: v ? v.description : tipoUpfrontFeeValue };
              //vm.resetUpfrontFeeRangeProperty();
            } else {
              selectChoices.tipologiaUpfrontFee = { code: '', description: '' };
            }
            properties.upfrontFeeRangeProperty.value = upfrontFeeValue;
            properties.upfrontFeeRangeProperty.rangeValues = upfrontFeeRangeValues;
            properties.tipoCommGestioneSeparataProperty.code = tipoCommGestioneSeparataCode;
            properties.tipoCommGestioneSeparataProperty.value = tipoCommGestioneSeparataValue;
            if (tipoCommGestioneSeparataCode.match(/\./)) {
              const v = vm.tipoCommGestioneSeparataOptions.find((o: any) => o.code === tipoCommGestioneSeparataCode);
              selectChoices.tipoCommGestioneSeparata = { code: tipoCommGestioneSeparataCode, description: v ? v.description : tipoCommGestioneSeparataValue };
              //vm.resetCommGestioneSeparataProperty();
            } else {
              selectChoices.tipoCommGestioneSeparata = { code: '', description: '' };
            }
            properties.commGestioneSeparataProperty.value = commGestioneSeparataValue;
            properties.commGestioneSeparataProperty.rangeValues = commGestioneSeparataRangeValues;
            properties.tipoCommFondiInterniAzionariProperty.code = tipoCommFIAzCode;
            properties.tipoCommFondiInterniAzionariProperty.value = tipoCommFIAzValue;
            properties.tipoCommFondiInterniAzionariProperty.prefill = true;
            if (tipoCommFIAzCode.match(/\./)) {
              const v = vm.tipoCommFondiInterniAzionariOptions.find((o: any) => o.code === tipoCommFIAzCode);
              selectChoices.tipoCommFondiInterniAzionari = { code: tipoCommFIAzCode, description: v ? v.description : tipoCommFIAzValue };
              //vm.resetCommFondiInterniAzionariProperty();
            } else {
              selectChoices.tipoCommFondiInterniAzionari = { code: '', description: '' };
            }
            properties.commFondiInterniAzionariProperty.value = commFIAzValue;
            properties.commFondiInterniAzionariProperty.rangeValues = commFIAzRangeValues;
            properties.tipoCommFondiInterniObbligazionariProperty.code = tipoCommFIObblCode;
            properties.tipoCommFondiInterniObbligazionariProperty.value = tipoCommFIObblValue;
            properties.tipoCommFondiInterniObbligazionariProperty.prefill = true;
            if (tipoCommFIObblCode.match(/\./)) {
              const v = vm.tipoCommFondiInterniObbligazionariOptions.find((o: any) => o.code === tipoCommFIObblCode);
              selectChoices.tipoCommFondiInterniObbligazionari = { code: tipoCommFIObblCode, description: v ? v.description : tipoCommFIObblValue };
              //vm.resetCommFondiInterniObbligazionariProperty();
            } else {
              selectChoices.tipoCommFondiInterniObbligazionari = { code: '', description: '' };
            }
            properties.commFondiInterniObbligazionariProperty.value = commFIObblValue;
            properties.commFondiInterniObbligazionariProperty.rangeValues = commFIObblRangeValues;
            properties.tipoCommFondiInterniBilanciatiProperty.code = tipoCommFIBilCode;
            properties.tipoCommFondiInterniBilanciatiProperty.value = tipoCommFIBilValue;
            properties.tipoCommFondiInterniBilanciatiProperty.prefill = true;
            if (tipoCommFIBilCode.match(/\./)) {
              const v = vm.tipoCommFondiInterniBilanciatiOptions.find((o: any) => o.code === tipoCommFIBilCode);
              selectChoices.tipoCommFondiInterniBilanciati = { code: tipoCommFIBilCode, description: v ? v.description : tipoCommFIBilValue };
              //vm.resetCommFondiInterniBilanciatiProperty();
            } else {
              selectChoices.tipoCommFondiInterniBilanciati = { code: '', description: '' };
            }
            properties.commFondiInterniBilanciatiProperty.value = commFIBilValue;
            properties.commFondiInterniBilanciatiProperty.rangeValues = commFIBilRangeValues;
            properties.tipoCommFondiInterniFlessibiliProperty.code = tipoCommFIFleCode;
            properties.tipoCommFondiInterniFlessibiliProperty.value = tipoCommFIFleValue;
            properties.tipoCommFondiInterniFlessibiliProperty.prefill = true;
            if (tipoCommFIFleCode.match(/\./)) {
              const v = vm.tipoCommFondiInterniFlessibiliOptions.find((o: any) => o.code === tipoCommFIFleCode);
              selectChoices.tipoCommFondiInterniFlessibili = { code: tipoCommFIFleCode, description: v ? v.description : tipoCommFIFleValue };
              //vm.resetCommFondiInterniFlessibiliProperty();
            } else {
              selectChoices.tipoCommFondiInterniFlessibili = { code: '', description: '' };
            }
            properties.commFondiInterniFlessibiliProperty.value = commFIFleValue;
            properties.commFondiInterniFlessibiliProperty.rangeValues = commFIFleRangeValues;
            properties.tipoCommFondiInterniMonetariProperty.code = tipoCommFIMonCode;
            properties.tipoCommFondiInterniMonetariProperty.value = tipoCommFIMonValue;
            properties.tipoCommFondiInterniMonetariProperty.prefill = true;
            if (tipoCommFIMonCode.match(/\./)) {
              const v = vm.tipoCommFondiInterniMonetariOptions.find((o: any) => o.code === tipoCommFIMonCode);
              selectChoices.tipoCommFondiInterniMonetari = { code: tipoCommFIMonCode, description: v ? v.description : tipoCommFIMonValue };
              //vm.resetCommFondiInterniMonetariProperty();
            } else {
              selectChoices.tipoCommFondiInterniMonetari = { code: '', description: '' };
            }
            properties.commFondiInterniMonetariProperty.value = commFIMonValue;
            properties.commFondiInterniMonetariProperty.rangeValues = commFIMonRangeValues;
            properties.tipologiaCommissioneOICRProperty.code = tipoCommOICRCode;
            properties.tipologiaCommissioneOICRProperty.value = tipoCommOICRValue;
            properties.tipologiaCommissioneOICRProperty.prefill = true;
            if (tipoCommOICRCode.match(/\./)) {
              const v = vm.tipologiaCommissioneOICROptions.find((o: any) => o.code === tipoCommOICRCode);
              selectChoices.tipologiaCommissioneOICR = { code: tipoCommOICRCode, description: v ? v.description : tipoCommOICRValue };
              //vm.resetCommissioneOICRProperties();
            } else {
              selectChoices.tipologiaCommissioneOICR = { code: '', description: '' };
            }
            properties.commissioneOICRAzionariProperty.value = commOICRAzValue;
            properties.commissioneOICRAzionariProperty.rangeValues = commOICRAzRangeValues;
            properties.commissioneOICRObbligazionariProperty.value = commOICRObblValue;
            properties.commissioneOICRObbligazionariProperty.rangeValues = commOICRObblRangeValues;
            properties.commissioneOICRBilanciatiProperty.value = commOICRBilValue;
            properties.commissioneOICRBilanciatiProperty.rangeValues = commOICRBilRangeValues;
            properties.commissioneOICRFlessibiliProperty.value = commOICRFleValue;
            properties.commissioneOICRFlessibiliProperty.rangeValues = commOICRFleRangeValues;
            properties.commissioneOICRMonetariProperty.value = commOICRMonValue;
            properties.commissioneOICRMonetariProperty.rangeValues = commOICRMonRangeValues;
            properties.commissioniOverperformanceProperty.code = commOverperformanceCode;
            properties.commissioniOverperformanceProperty.value = commOverperformanceValue;
            if (commOverperformanceCode.match(/\./)) {
              const v = vm.commissioniOverperformanceOptions.find((o: any) => o.code === commOverperformanceCode);
              selectChoices.commissioniOverperformance = { code: commOverperformanceCode, description: v ? v.description : commOverperformanceValue };
            } else {
              selectChoices.commissioniOverperformance = { code: '', description: '' };
            }
            properties.costoGaranziaMorteProperty.value = costoGarCasoMorteRamo3Value;
            properties.applicazioneCommissioniUscitaProperty.code = applCommUscitaCode;
            properties.applicazioneCommissioniUscitaProperty.value = applCommUscitaValue;
            if (applCommUscitaCode.match(/\./)) {
              const v = vm.applicazioneCommissioniUscitaOptions.find((o: any) => o.code === applCommUscitaCode);
              selectChoices.applicazioneCommissioniUscita = { code: applCommUscitaCode, description: v ? v.description : applCommUscitaValue };
              //vm.setCommissioniUscita();
            } else {
              selectChoices.applicazioneCommissioniUscita = { code: '', description: '' };
            }
            properties.commissioneUscitaProperty.value = commUscitaValue;
            properties.commissioneUscitaProperty.rangeValues = commUscitaRangeValues;
            properties.KIDProperty.code = kidCode;
            properties.KIDProperty.value = kidValue;
            if (kidCode.match(/\./)) {
              const v = vm.KIDOptions.find((o: any) => o.code === kidCode);
              selectChoices.KID = { code: kidCode, description: v ? v.description : kidValue };
              //vm.setKIDStress();
            } else {
              selectChoices.KID = { code: '', description: '' };
            }
            properties.scenarioKIDStressProperty.value = kidStressValue;
            properties.scenarioKIDStressProperty.rangeValues = kidStressRangeValues;
            properties.scenarioKIDSfavorevoleProperty.value = kidSfavorevoleValue;
            properties.scenarioKIDSfavorevoleProperty.rangeValues = kidSfavorevoleRangeValues;
            properties.scenarioKIDModeratoProperty.value = kidModeratoValue;
            properties.scenarioKIDModeratoProperty.rangeValues = kidModeratoRangeValues;
            properties.scenarioKIDFavorevoleProperty.value = kidFavorevoleValue;
            properties.scenarioKIDFavorevoleProperty.rangeValues = kidFavorevoleRangeValues;
            properties.scenarioKIDCasoMorteProperty.value = kidMorteValue;
            properties.scenarioKIDCasoMorteProperty.rangeValues = kidMorteRangeValues;
            properties.GKIDProperty.gkid = gkidValue;
            properties.campoNoteProperty.value = campoNoteValue;
          })
          .catch(() => {
            vm.openModalError();
          })

        vm.stopLoading();
      }
    },
    cleanAllProperties: function() {
      const vm = this as any;

      properties.nomeProperty.value = "";
      properties.emittenteProperty.value = "";
      properties.distributoreProperty.value = "";
      properties.mercatoProperty.code = ""; properties.mercatoProperty.value = "";
      properties.destinatariProperty.code = ""; properties.destinatariProperty.value = "";
      properties.canaleProperty.code = ""; properties.canaleProperty.value = "";
      properties.tipoProdottoProperty.code = ""; properties.tipoProdottoProperty.value = "";
      properties.tipoSottostantiProperty.code = ""; properties.tipoSottostantiProperty.value = "";
      properties.edizioneProperty.value = ""; properties.edizioneProperty.dateValue = null;
      properties.prodCommProperty.code = ""; properties.prodCommProperty.value = "";
      properties.inizioCommProperty.value = ""; properties.inizioCommProperty.dateValue = null;
      properties.fineCommProperty.value = ""; properties.fineCommProperty.dateValue = null;
      properties.tipoPremioProperty.code = ""; properties.tipoPremioProperty.value = "";
      properties.prodCollegatoProperty.code = ""; properties.prodCollegatoProperty.value = "";
      properties.codProdCollegatoProperty.value = "";
      properties.relazioneProdCollegatoProperty.code = ""; properties.relazioneProdCollegatoProperty.value = "";
      properties.orizzonteTemporaleProperty.value = "";
      properties.tipologiaDurationProperty.code = ""; properties.tipologiaDurationProperty.value = "";
      
      properties.dataScadenzaProperty.value = ""; properties.dataScadenzaProperty.dateValue = null;
      properties.dataScadenzaProperty.rangeValues = [ { order: 0, from: "", to: "", value: "" } ];

      properties.importoMinimoProperty.value = "";
      properties.importoMassimoProperty.value = "";
      properties.retrocessioneUpfrontProperty.value = "";
      properties.retrocessioneGestSepProperty.value = "";
      properties.retrocessioneRamIIIProperty.value = "";
      properties.gsWeightMinProperty.value = "";
      properties.gsWeightMaxProperty.value = "";
      properties.tipoCalcoloBonusIngressoProperty.code = ""; properties.tipoCalcoloBonusIngressoProperty.value = "";
      
      properties.bonusIngressoProperty.value = "";
      properties.bonusIngressoProperty.rangeValues = [ { order: 0, from: "", to: "", value: "" } ];

      properties.tipoCalcoloBonusFedeltaProperty.code = ""; properties.tipoCalcoloBonusFedeltaProperty.value = "";
      
      properties.bonusFedeltaProperty.value = "";
      properties.bonusFedeltaProperty.rangeValues = [ { order: 0, from: "", to: "", value: "" } ];

      properties.speseAmministrativeAperturaContrattoProperty.value = "";
      properties.speseAmministrativeVersamentoPACProperty.value = "";
      properties.tipologiaUpfrontFeeProperty.code = ""; properties.tipologiaUpfrontFeeProperty.value = "";
      
      properties.upfrontFeeRangeProperty.value = "";
      properties.upfrontFeeRangeProperty.rangeValues = [ { order: 0, from: "", to: "", value: "" } ];

      properties.tipoCommGestioneSeparataProperty.code = ""; properties.tipoCommGestioneSeparataProperty.value = "";
      
      properties.commGestioneSeparataProperty.value = "";
      properties.commGestioneSeparataProperty.rangeValues = [ { order: 0, from: "", to: "", value: "" } ];

      properties.tipoCommFondiInterniAzionariProperty.code = ""; properties.tipoCommFondiInterniAzionariProperty.value = "";

      properties.commFondiInterniAzionariProperty.value = "";
      properties.commFondiInterniAzionariProperty.rangeValues = [ { order: 0, from: "", to: "", value: "" } ];

      properties.tipoCommFondiInterniObbligazionariProperty.code = ""; properties.tipoCommFondiInterniObbligazionariProperty.value = "";
      
      properties.commFondiInterniObbligazionariProperty.value = "";
      properties.commFondiInterniObbligazionariProperty.rangeValues = [ { order: 0, from: "", to: "", value: "" } ];
      
      properties.tipoCommFondiInterniBilanciatiProperty.code = ""; properties.tipoCommFondiInterniBilanciatiProperty.value = "";
      
      properties.commFondiInterniBilanciatiProperty.value = "";
      properties.commFondiInterniBilanciatiProperty.rangeValues = [ { order: 0, from: "", to: "", value: "" } ];

      properties.tipoCommFondiInterniFlessibiliProperty.code = ""; properties.tipoCommFondiInterniFlessibiliProperty.value = "";
      
      properties.commFondiInterniFlessibiliProperty.value = "";
      properties.commFondiInterniFlessibiliProperty.rangeValues = [ { order: 0, from: "", to: "", value: "" } ];
      
      properties.tipoCommFondiInterniMonetariProperty.code = ""; properties.tipoCommFondiInterniMonetariProperty.value = "";
      
      properties.commFondiInterniMonetariProperty.value = "";
      properties.commFondiInterniMonetariProperty.rangeValues = [ { order: 0, from: "", to: "", value: "" } ];
      
      properties.tipologiaCommissioneOICRProperty.code = ""; properties.tipologiaCommissioneOICRProperty.value = "";

      properties.commissioneOICRAzionariProperty.value = "";
      properties.commissioneOICRAzionariProperty.rangeValues = [ { order: 0, from: "", to: "", value: "" } ];

      properties.commissioneOICRObbligazionariProperty.value = "";
      properties.commissioneOICRObbligazionariProperty.rangeValues = [ { order: 0, from: "", to: "", value: "" } ];

      properties.commissioneOICRBilanciatiProperty.value = "";
      properties.commissioneOICRBilanciatiProperty.rangeValues = [ { order: 0, from: "", to: "", value: "" } ];

      properties.commissioneOICRFlessibiliProperty.value = "";
      properties.commissioneOICRFlessibiliProperty.rangeValues = [ { order: 0, from: "", to: "", value: "" } ];

      properties.commissioneOICRMonetariProperty.value = "";
      properties.commissioneOICRMonetariProperty.rangeValues = [ { order: 0, from: "", to: "", value: "" } ];

      properties.commissioniOverperformanceProperty.code = ""; properties.commissioniOverperformanceProperty.value = "";

      properties.costoGaranziaMorteProperty.value = "";

      properties.applicazioneCommissioniUscitaProperty.code = ""; properties.applicazioneCommissioniUscitaProperty.value = "";
      
      properties.commissioneUscitaProperty.value = "";
      properties.commissioneUscitaProperty.rangeValues = [ { order: 0, from: "", to: "", value: "" } ];

      properties.KIDProperty.code = ""; properties.KIDProperty.value = "";

      properties.scenarioKIDStressProperty.value = "";
      properties.scenarioKIDStressProperty.rangeValues = [ { order: 0, from: "", to: "", value: "" } , { order: 1, from: "", to: "", value: "" } , { order: 2, from: "", to: "", value: "" } ];

      properties.scenarioKIDSfavorevoleProperty.value = "";
      properties.scenarioKIDSfavorevoleProperty.rangeValues = [ { order: 0, from: "", to: "", value: "" } , { order: 1, from: "", to: "", value: "" } , { order: 2, from: "", to: "", value: "" } ];

      properties.scenarioKIDModeratoProperty.value = "";
      properties.scenarioKIDModeratoProperty.rangeValues = [ { order: 0, from: "", to: "", value: "" } , { order: 1, from: "", to: "", value: "" } , { order: 2, from: "", to: "", value: "" } ];

      properties.scenarioKIDFavorevoleProperty.value = "";
      properties.scenarioKIDFavorevoleProperty.rangeValues = [ { order: 0, from: "", to: "", value: "" } , { order: 1, from: "", to: "", value: "" } , { order: 2, from: "", to: "", value: "" } ];

      properties.scenarioKIDCasoMorteProperty.value = "";
      properties.scenarioKIDCasoMorteProperty.rangeValues = [ { order: 0, from: "", to: "", value: "" } , { order: 1, from: "", to: "", value: "" } , { order: 2, from: "", to: "", value: "" } ];

      properties.GKIDProperty.value = "";
      properties.GKIDProperty.gkid = { order :0, costs: [{ from: "", to: "" },{ from: "", to: "" },{ from: "", to: "" }], risk: { from: "", to: "" } },

      properties.campoNoteProperty.value = "";


      selectChoices.mercato = { code: "", description: "" };
      selectChoices.destinatari = { code: "", description: "" };
      selectChoices.canale = { code: "", description: "" };
      selectChoices.tipoProdotto = { code: "", description: "" };
      selectChoices.tipoSottostanti = { code: "", description: "" };
      selectChoices.prodComm = { code: "", description: "" };
      selectChoices.tipoPremio = { code: "", description: "" };
      selectChoices.prodCollegato = { code: "", description: "" };
      selectChoices.relazioneProdCollegato = { code: "", description: "" };
      selectChoices.tipologiaDuration = { code: "", description: "" };
      selectChoices.tipoCalcoloBonusIngresso = { code: "", description: "" };
      selectChoices.tipoCalcoloBonusFedelta = { code: "", description: "" };
      selectChoices.tipologiaUpfrontFee = { code: "", description: "" };
      selectChoices.tipoCommGestioneSeparata = { code: "", description: "" };
      selectChoices.tipoCommFondiInterniAzionari = { code: "", description: "" };
      selectChoices.tipoCommFondiInterniObbligazionari = { code: "", description: "" };
      selectChoices.tipoCommFondiInterniBilanciati = { code: "", description: "" };
      selectChoices.tipoCommFondiInterniFlessibili = { code: "", description: "" };
      selectChoices.tipoCommFondiInterniMonetari = { code: "", description: "" };
      selectChoices.tipologiaCommissioneOICR = { code: "", description: "" };
      selectChoices.commissioniOverperformance = { code: "", description: "" };
      selectChoices.applicazioneCommissioniUscita = { code: "", description: "" };
      selectChoices.KID = { code: "", description: "" };
    },
    home: function() {
      const vm = this as any;
      vm.$router.push({ name: 'home', params: {user: vm.loggedUser}});
    },
    isNil,
    getUser: async function() {
      const vm = this as any;
      const serviceCallReturnValue = await requestService.getUser()
        .then(handleResponse)
        .then((result: any) => {
          vm.loggedUser = result;
        });
    },
  },
  created() {
    const vm = this as any;

    if (vm.$props.user == undefined) {
      vm.getUser();
    }

    vm.cleanAllProperties();

    vm.prefillProperties();
  },
  destroyed() {
    const vm = this as any;
    //vm.stopLoading();
    vm.closeModalError();
  },  
});
